export const TYPES = {
  DANGER: "DANGER",
};
